<div class="k-overlay" *ngIf="dialogSearchKno2DirectoryOpened"></div>
<kendo-window *ngIf="dialogSearchKno2DirectoryOpened" (close)="closeSearch(true)" [width]="750"
    (keydown)="modalKeyDown($event)" [state]="windowState">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">{{ 'DIRECTORY-SEARCH-KNO2' | translate }}</h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <!--Hiding restore because modal show behind and unable to resolve 
        <button kendoWindowRestoreAction></button>-->
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <app-kno2-search [allowSelection]="allowSelection" [singleSelectionOnly]="singleSelectionOnly"
        (selectProvider)="onSetProviders($event)">
    </app-kno2-search>
    <kendo-dialog-actions>
        <button class="k-button" (click)="closeSearch(true)">{{ allowSelection ? 'CANCEL' : 'CLOSE' | translate }}
        </button>
        <button *ngIf="allowSelection" kendoButton [primary]="true" (click)="onSelectedProviders()"
            style="margin-right: 8px;" type="button" class="far fa-check" [disabled]="getSelectedCount() === 0">
            {{ 'SELECT' | translate }} <span *ngIf="getSelectedCount() > 0">({{getSelectedCount()}})</span>
        </button>
    </kendo-dialog-actions>
</kendo-window>